<template>
  <div>
    <b-container>
      <div class="row justify-content-center">
        <div class="column w-75">
          <div class="mt-4 d-flex align-items-start justify-content-between">
            <back-arrow :title="$t('my.matches.title')"/>
          </div>

          <transition-group v-if="isLoading" appear name="listCustomTransition" tag="div">
            <div key="my-matches-PlaceHolder-draft" class="d-flex flex-column justify-content-center mt-4 m b-4">
              <div class="matches-title mt-2 mb-2">
                {{$t('my.matches.current.matches')}}
              </div>
              <PlaceholderCardAnnonce :isAnimated=true :isGradient=false customDisplayClass="my-matches-placeholder mb-2"></PlaceholderCardAnnonce>

              <div class="matches-title mt-4 mb-2">
                {{$t('my.matches.validated.matches')}}
              </div>
              <PlaceholderCardAnnonce :isAnimated=true :isGradient=false customDisplayClass="my-matches-placeholder mb-2"></PlaceholderCardAnnonce>

              <div class="matches-title mt-4 mb-2">
                {{$t('my.matches.refused.matches')}}
              </div>
              <PlaceholderCardAnnonce :isAnimated=true :isGradient=false customDisplayClass="my-matches-placeholder mb-2"></PlaceholderCardAnnonce>
            </div>
          </transition-group>

          <transition-group v-if="!isLoading" name="listCustomTransition" >
            <div key="my-matches-draft" class="d-flex flex-column justify-content-center mt-4 m b-4">
              <div class="matches-title mt-2 mb-2">
                {{$t('my.matches.current.matches')}}
              </div>
              <matches-card-image v-if="currentMatches.length > 0" v-for="currentMatch in currentMatches" :key="currentMatch.serverId" :match="currentMatch" class="mb-2"/>
              <div v-if="currentMatches.length === 0" class="card-container">
                <div class="d-flex">
                  <div class="p-3">
                    <img :src="require(`@/assets/images/b122/img-confused.png`)" alt="no result"
                         class="empty-state-img-home">
                  </div>
                  <div class="empty-state-text">
                    {{$t('my.matches.no.current.matches')}}
                  </div>
                </div>
              </div>

              <div class="matches-title mt-4 mb-2">
                {{$t('my.matches.validated.matches')}}
              </div>
              <matches-card-image v-if="validatedMatches.length > 0" v-for="validatedMatch in validatedMatches" :key="validatedMatch.serverId" :match="validatedMatch" class="mb-2"/>
              <div v-if="validatedMatches.length === 0" class="card-container">
                <div class="d-flex">
                  <div class="p-3">
                    <img :src="require(`@/assets/images/b122/img-confused.png`)" alt="no result"
                         class="empty-state-img-home">
                  </div>
                  <div class="empty-state-text">
                    {{$t('my.matches.no.validated.matches')}}
                  </div>
                </div>
              </div>

              <div class="matches-title mt-4 mb-2">
                {{$t('my.matches.refused.matches')}}
              </div>
              <PlaceholderCardAnnonce :isAnimated=true :isGradient=false customDisplayClass="my-matches-placeholder mb-2" v-if="isLoading"></PlaceholderCardAnnonce>
              <matches-card-image v-if="refusedMatches.length > 0" v-for="refusedMatch in refusedMatches" :key="refusedMatch.serverId" :match="refusedMatch" class="mb-2"/>
              <div v-if="refusedMatches.length === 0" class="card-container">
                <div class="d-flex">
                  <div class="p-3">
                    <img :src="require(`@/assets/images/b122/img-confused.png`)" alt="no result"
                         class="empty-state-img-home">
                  </div>
                  <div class="empty-state-text">
                    {{$t('my.matches.no.refused.matches')}}
                  </div>
                </div>
              </div>

            </div>
          </transition-group>

        </div>
      </div>

    </b-container>
  </div>
</template>

<script>
import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow.vue'
import MatchesCardImage from "../../components/annonce/MatchesCardImage";
import PlaceholderCardAnnonce from "../search/PlaceholderCardAnnonce";

export default {

  name: 'MyMatches',
  components: {BackArrow, MatchesCardImage, PlaceholderCardAnnonce},

  data() {
    return {
      isLoading: true,
      currentMatches: [],
      validatedMatches: [],
      refusedMatches: []
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {

    async fetchData() {
      this.fetchMatches()
    },

    fetchMatches() {
      api
        .get(`/user/getUserInfoMatches`)
        .then(response => {
          this.currentMatches = response.data.currentMatches
          this.validatedMatches = response.data.validatedMatches
          this.refusedMatches = response.data.refusedMatches
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.category-card {
  height: 120px;
  border-radius: var(--fifth-border-radius);
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
}

.category-card-title {
  font-family: "KumbhSans-Regular", "Arial", sans-serif;
  font-size: var(--menu-font-size);
  color: var(--main-grey-light);
}

.category-number {
  font-family: Agbalumo-Regular, "Arial", sans-serif;
  font-size: 54px;
  color: var(--main-yellow-medium);
  line-height: 50px;
}

.category-icon {
  font-size: 100px;
  color: var(--main-black-light);
}

.coin-image {
  width: 24px;
  height: 24px;
}

.matches-nb {
  font-size: 30px;
}

.currentLoopGrades {
  display: flex;
  justify-content: center;
  gap: 6px;
  font-family: Agbalumo-Regular, "Arial", sans-serif;
  font-size: var(--title-level-two-font-size);
  color: var(--main-grey-light);
}

.currentLoopGrade {
  color: var(--main-yellow-medium);
}

.currentLevel {
  width: 100%;
  font-family: Agbalumo-Regular, "Arial", sans-serif;
  font-size: var(--title-level-two-font-size);
  color: var(--main-grey-medium);
}

.matches-title {
  width: 100%;
  color: var(--main-grey-medium);
  font-weight: bold;
}

.loops {
  color: var(--main-grey-medium);
}

.loop {
  display: flex;
  align-items: center;
  gap: 8px;
}

.loopName{
  font-family: Agbalumo-Regular, "Arial", sans-serif;
  font-size: var(--menu-font-size);
  color: var(--main-yellow-medium);
  margin-bottom: 6px;
}

.vertical-line {
  width: 5px;
}

.flex-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.vertical-line {
  width: 5px;
  height: 20px;
  background-color: var(--main-grey-medium);
}

.circle {
  width: 15px;
  height: 15px;
  background-color: var(--main-grey-medium);;
  border-radius: 50%;
}

.hidden-bar {
  opacity: 0;
}

.my-matches-placeholder {
  max-width: 800px !important;
  width: 800px !important;
  height: 162px !important;
}
.empty-state-text {
  align-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/user/MyMatches.vue